// extracted by css-extract-rspack-plugin
var _1 = "K3F7yICZKxAcihjV";
export { _1 as "cardBadgeStyle" }
// extracted by css-extract-rspack-plugin
var _1 = "K3F7yICZKxAcihjV";
export { _1 as "cardBadgeStyle" }
